import { render, staticRenderFns } from "./customizations.vue?vue&type=template&id=6f15cbbd&scoped=true"
import script from "./customizations.vue?vue&type=script&lang=js"
export * from "./customizations.vue?vue&type=script&lang=js"
import style0 from "./customizations.vue?vue&type=style&index=0&id=6f15cbbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f15cbbd",
  null
  
)

export default component.exports